import React from 'react';
import { motion } from 'framer-motion';
export function ProductSection() {
  return <section className="bg-cream-dark py-16 md:py-24" data-id="element-164">
      <div className="max-w-editorial mx-auto px-4" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-charcoal mb-6" data-id="element-167">
            Was sieht eine Routine aus, die auf den richtigen Überzeugungen
            aufbaut?
          </h2>
          <div className="space-y-4 text-lg text-charcoal/90 text-left" data-id="element-168">
            <p data-id="element-169">
              Alles oben Genannte führt zur selben Schlussfolgerung: Die meisten
              Haaröle versagen bei Frauen mit dünner werdendem Haar nicht, weil
              sie schlechte Inhaltsstoffe enthalten – sondern weil sie für das
              falsche Ziel konzipiert sind: die Haarsträhne statt die Kopfhaut.
            </p>
            <p data-id="element-170">
              Eine Routine, die wirkt, muss dort beginnen, wo sichtbare
              Ausdünnung tatsächlich anfängt.
            </p>
            <p data-id="element-171">
              Das bedeutet: Die Kopfhaut und Haarwurzelzone direkt zu targeten.
              Eine Formel zu verwenden, die einzieht statt zu beschichten. Eine
              Struktur aufzubauen, die man lang genug durchhalten kann, um sie
              fair zu beurteilen. Und Fortschritt an den Signalen zu messen, die
              zuerst ankommen – weniger Haarausfall, eine ruhigere Kopfhaut,
              mehr Selbstvertrauen – statt ausschließlich auf das dramatische
              Vorher/Nachher zu warten, das Monate länger dauert.
            </p>
            <p className="font-semibold text-xl text-center mt-8 font-heading text-accent" data-id="element-172">
              Genau dafür wurde Luisé entwickelt.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-173">
          <div className="md:flex" data-id="element-174">
            <div className="md:w-1/2 bg-accent-light p-8 flex items-center justify-center" data-id="element-175">
              <img src="https://cdn.magicpatterns.com/uploads/gsPr3CnbJLSLSFX3QQ8FLW/image2.png" alt="Luisé Thrive Hair Oil – Flasche und Verpackung mit natürlichen Inhaltsstoffen" className="w-full max-w-sm h-auto rounded-lg shadow-lg object-cover" data-id="element-176" />
            </div>
            <div className="md:w-1/2 p-8 md:p-10" data-id="element-177">
              <h3 className="text-2xl font-heading font-semibold text-charcoal mb-4" data-id="element-178">
                Luisé Scalp-First Hair Oil
              </h3>
              <p className="text-charcoal/80 mb-6" data-id="element-179">
                Luisé ist kein weiteres Glanzöl mit einem Rosmarin-Etikett. Es
                ist ein kopfhaut-zentrisches Ritual für Frauen, die sichtbare
                Ausdünnung, Haarausfall, reduzierte Dichte und frühe
                Veränderungen an der Scheitellinie erleben – entwickelt aus der
                Überzeugung, dass die Strähne ein Symptom ist, und die Kopfhaut
                der Ort, wo die Arbeit stattfindet.
              </p>

              <h4 className="font-ui font-semibold text-sm tracking-wider uppercase text-charcoal mb-3" data-id="element-180">
                So funktioniert es:
              </h4>
              <ul className="space-y-3 mb-8" data-id="element-181">
                {['Präzisionspipette zielt direkt auf die Haarwurzelzone – nicht auf die Längen – für maximalen Kopfhautkontakt', 'Leichte, fettfreie Formel, die einzieht statt zu beschichten', 'Pre-Wash oder gezieltes Leave-in-Ritual – passend zu deinem bestehenden Waschrhythmus', 'Formuliert für konsequente, tägliche Anwendung – denn die Routine, die du durchhältst, schlägt die, die du scheust'].map((item, i) => <li key={i} className="flex items-start" data-id="element-182">
                    <span className="text-accent mr-2 mt-1" data-id="element-183">•</span>
                    <span className="text-charcoal/90" data-id="element-184">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-charcoal text-cream p-8 md:p-10" data-id="element-185">
            <h4 className="font-heading text-xl mb-6 text-center" data-id="element-186">
              Was du erwarten kannst:
            </h4>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-187">
              <div className="border-l-2 border-accent/50 pl-4" data-id="element-188">
                <div className="font-ui font-semibold text-accent mb-1" data-id="element-189">
                  Wochen 1–2
                </div>
                <p className="text-cream/80 text-sm" data-id="element-190">
                  Die Kopfhaut fühlt sich gepflegt und ruhiger an; die Anwendung
                  ist einfach und störungsfrei
                </p>
              </div>
              <div className="border-l-2 border-accent/50 pl-4" data-id="element-191">
                <div className="font-ui font-semibold text-accent mb-1" data-id="element-192">
                  Wochen 3–4
                </div>
                <p className="text-cream/80 text-sm" data-id="element-193">
                  Viele Frauen bemerken weniger Haarausfall in Bürste und
                  Duschablauf
                </p>
              </div>
              <div className="border-l-2 border-accent/50 pl-4" data-id="element-194">
                <div className="font-ui font-semibold text-accent mb-1" data-id="element-195">
                  Wochen 6–10
                </div>
                <p className="text-cream/80 text-sm" data-id="element-196">
                  Die Haarwurzelzone sieht voller aus; Babyhaare können an
                  Haarlinie und Schläfen erscheinen
                </p>
              </div>
              <div className="border-l-2 border-accent/50 pl-4" data-id="element-197">
                <div className="font-ui font-semibold text-accent mb-1" data-id="element-198">
                  Bei konsequenter Anwendung
                </div>
                <p className="text-cream/80 text-sm" data-id="element-199">
                  Mehr Selbstvertrauen beim Stylen, weniger sichtbare Kopfhaut,
                  weniger tägliche Panik beim Haarewaschen
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <p className="mt-8 text-center text-charcoal/80 max-w-2xl mx-auto italic pt-[10px] pb-[10px]" data-id="element-200">
          Luisé ist für Frauen, die eine schöne, feminine, nicht-klinische
          Routine wollen – kein pharmazeutisches Dauerpräparat. Es wurde
          entwickelt, um das Kopfhaut-Milieu zu unterstützen, aus dem dein Haar
          wächst – sodass sich mit der Zeit das, was du im Spiegel siehst,
          verändert.
        </p>
      </div>
      <div className="flex justify-center" data-id="element-201">
        <a href="https://shopavenso.com/products/eelhoe-haarol" target="_blank" rel="noopener noreferrer" className="inline-block bg-accent hover:bg-accent-light text-charcoal font-ui font-semibold uppercase tracking-wider py-4 px-10 rounded-sm transition-colors duration-300 w-full md:w-auto text-center" data-id="element-202">
          Jetzt Verfügbarkeit prüfen
        </a>
      </div>
    </section>;
}